import { ColumnsFactory } from "../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.NumericColumn("Cod. SubFunción", "idSubFuncion"),
    ColumnsFactory.TextColumn("SubFunción", "subFuncion"),
    ColumnsFactory.TextColumn("Tipo", "tipo"),
    ColumnsFactory.NumericColumn("Margen", "margen"),
    ColumnsFactory.BooleanColumn("Facturable", "facturable"),
    ColumnsFactory.TextColumn("Concepto Facturación", "concepto")
  ];
};
